import React from 'react';
import { func, bool, string, array, number } from 'prop-types';
import classNames from 'classnames';
import { Popover } from '@fiverr-private/fit';
import SellerGigs from '../SellerGigs';
import AvailableServicesTrigger from '../AvailableServicesTrigger';

import './style.scss';

const AvailableServicesPopover = ({ className, gigs, total, loading, onOpen }) => (
    <Popover
        className={classNames('available-services-popover', className)}
        content={<SellerGigs gigs={gigs} loading={loading} total={total} />}
        contentClassName="available-services-content"
        boxClassName="available-services-box"
        boxContentClassName="available-services-box-content"
        openClassName="available-services-open"
        position={Popover.POSITIONS.RIGHT}
        appendToBody={false}
        onOpen={onOpen}
    >
        <AvailableServicesTrigger total={total} />
    </Popover>
);

AvailableServicesPopover.propTypes = {
    className: string,
    gigs: array,
    total: number,
    loading: bool,
    onOpen: func,
};

export default AvailableServicesPopover;
